var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col h-full w-full"},[_c('h2',{staticClass:"font-extrabold"},[_vm._v(_vm._s(_vm.product.part.nkrCode))]),_c('h3',[_vm._v(_vm._s(_vm.productTitle))]),(_vm.productImageUrl)?_c('div',{staticClass:"w-full h-full product-image-box",style:({ 'background-image': `url(${_vm.productImageUrl})` })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }